export function matchingOptions(options, query) {
  const words = String(query || '').toLowerCase().trim().split(/\s+/).filter(Boolean);
  return options.filter(option => words.every(word => option.label.toLowerCase().includes(word)));
}
export async function loadConversionLists(get, receive, failed) {
  const jobs = [
    ['requests', '/inventory-control/mcr'],
    ['destinations', '/inventory-control/skus'],
    ['rules', '/inventory-control/conversion-rules'],
    ['jobs', '/job-orders?limit=100'],
    ['parents', '/materials']
  ];
  await Promise.all(jobs.map(async ([name, url]) => {
    try {
      const response = await get(url);
      if (!Array.isArray(response?.data)) throw new Error('Unexpected list response');
      receive(name, response.data);
    } catch (error) { failed(name, error.message || 'Unable to load list'); }
  }));
}
